import { curry1 } from './curry1';
import { curry2 } from './curry2';
import { curry3 } from './curry3';
import { curry4 } from './curry4';
export function curry5(fn) {
    function curried(a, b, c, d, e) {
        switch (arguments.length) {
            case 0: return curried;
            case 1: return curry4(function (b, c, d, e) { return fn(a, b, c, d, e); });
            case 2: return curry3(function (c, d, e) { return fn(a, b, c, d, e); });
            case 3: return curry2(function (d, e) { return fn(a, b, c, d, e); });
            case 4: return curry1(function (e) { return fn(a, b, c, d, e); });
            default: return fn(a, b, c, d, e);
        }
    }
    return curried;
}
//# sourceMappingURL=curry5.js.map